var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9451 19.5506C11.6459 19.8502 11.2843 20 10.8603 20C10.4364 20 10.0748 19.8502 9.77556 19.5506L0.42394 10.1873C0.257689 10.0208 0.14547 9.84603 0.0872818 9.66292C0.0290939 9.47982 0 9.28839 0 9.08864V1.49813C0 1.06534 0.141313 0.707449 0.42394 0.424469C0.706567 0.14149 1.06401 0 1.49626 0H9.07731C9.27681 0 9.47631 0.0291303 9.67581 0.0873908C9.87531 0.145651 10.0582 0.258011 10.2244 0.424469L19.5262 9.73783C19.8421 10.0541 20 10.4245 20 10.8489C20 11.2734 19.8421 11.6438 19.5262 11.9601L11.9451 19.5506ZM4.11471 5.39326C4.46384 5.39326 4.76725 5.26425 5.02494 5.00624C5.28263 4.74823 5.41147 4.44444 5.41147 4.09488C5.41147 3.74532 5.28263 3.44153 5.02494 3.18352C4.76725 2.92551 4.46384 2.7965 4.11471 2.7965C3.76559 2.7965 3.46218 2.92551 3.20449 3.18352C2.9468 3.44153 2.81796 3.74532 2.81796 4.09488C2.81796 4.44444 2.9468 4.74823 3.20449 5.00624C3.46218 5.26425 3.76559 5.39326 4.11471 5.39326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountWhiteSmall);
export default __webpack_public_path__ + "static/media/discount_white_small.30be2be4b1eb559b1fc2fb4f1314b36f.svg";
export { ForwardRef as ReactComponent };